// 브라우저 플랫폼 판정 — **user agent** 기준. 스토어 링크 분기·모바일 전용 UI 노출이 쓴다.
//
// ⚠️ `getAppType()`(shared/bridge)과 **축이 다르다**: 저건 native 셸 안에서 도는지를 `__NATIVE__` 로 보고
// 브라우저에선 항상 `'web'` 이다. 여기 함수들은 그 반대편 — **브라우저가 어떤 기기 위에 있는지**를 본다.
// 구독·결제 화면은 외부 브라우저에서 열리므로 이쪽 판정이 필요하다.

/**
 * iPadOS 13+ 위장 판별 — UA 를 데스크톱 Safari(`Macintosh`)로 보내므로 UA 문자열만으로는 Mac 과 구분되지
 * 않는다. 터치 포인트가 있는 Mac 은 실제로는 iPad 다(데스크톱 Mac 은 `maxTouchPoints === 0`).
 */
const isIpadInDesktopDisguise = (ua: string): boolean =>
  /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;

/**
 * **모바일 기기의 브라우저인가** — 앱 설치가 실제로 가능한 환경인지 가른다.
 * 앱 유도 UI(스토어 이동 버튼)를 데스크톱에서 감추는 데 쓴다.
 *
 * `isApplePlatform()` 과 달리 **데스크톱 Mac 은 제외**한다 — 두 함수의 질문이 다르다:
 * 이건 "설치할 수 있는 기기인가", 저건 "어느 스토어를 보여줄 기기인가".
 */
export function isMobileBrowser(): boolean {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod|Android/.test(ua) || isIpadInDesktopDisguise(ua);
}

/**
 * **Apple 플랫폼 브라우저인가** — iOS 기기와 **macOS 데스크톱을 함께** 본다(스토어 링크 분기용).
 *
 * Mac 을 포함하는 이유: 데스크톱은 어차피 그 자리에서 설치가 안 되니 "어느 스토어 페이지를 띄울까"의
 * 문제인데, Mac 사용자에게 Play 스토어를 여는 쪽이 더 어긋난다(대개 iPhone 을 함께 쓴다).
 * 덤으로 iPadOS 위장 케이스도 자연히 흡수된다 — `Macintosh` 가 이미 Apple 로 잡히므로.
 */
export function isApplePlatform(): boolean {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
}
